<template lang="pug">
.container
  .fixedFloatBar
    el-button(plain, @click="clickCancel") ยกเลิก
    el-button(type="primary", @click="clickSave", :disabled="isDisabledSave")
      div(v-if="type === 'create'") หาผู้ดูแล
      div(v-else) อัพเดท
  .form-container
    el-form.form(ref="form", :model="form", :rules="rules", label-width="270px")
      el-row
        el-col(:span='18')
          .head.alignRight หาผู้ดูแล
        el-col(:span='6')
          el-button(v-if="type === 'edit'", type="primary", @click="clickDelete", plain, icon="el-icon-delete", style="display: flex;")
              | ลบ
      el-form-item(style="margin-bottom: 45px")
        span(slot="label")
          i.el-icon-mobile-phone
          span.label เวรที่ต้องการ
        .content.paragraph-14-gray-1 {{ shiftSummary }}
      el-form-item
       .calendar-container
        .btn-calendar-container
          el-button(icon="el-icon-arrow-left", @click.native="goPreviousMonth", style="margin-top: -4px;")
          el-button(icon="el-icon-arrow-right",  @click.native="goNextMonth", style="margin-left: 599px; min-width: 60px; max-width: 60px; margin-top: -4px;")
        day-picker-calendar(id="calendarBooking", v-model="form.dates", ref="bookingCalendar", :isAllowAddEvent='false', :maxDate="allowDates.length" :allowDates="allowDates", :typeCalendar="calendarType")
      el-form-item(style="margin-bottom: 45px")
        span(slot="label")
          i.el-icon-mobile-phone
          span.label จำนวนเวร
        .content.paragraph-14-gray-1 {{ totalDays }} เวร
      el-form-item(prop="price.rate", style="margin-bottom: 45px")
        span(slot="label")
            i.el-icon-mobile-phone
            span.require-star *
            span.label ราคาที่จ่ายผู้ดูแลต่อเวร
        .input-container
          el-input(v-model.number="form.price.rate").short
          .input-trailing-text.paragraph-14-gray-1 บาท
      el-form-item(style="margin-bottom: 45px")
        span.label(slot="label") ราคารวมที่จ่ายผู้ดูแล
        .content.paragraph-14-gray-1 {{ totalPrice | numberFormat }} บาท
</template>

<style lang="scss" scoped>
  $float-bar: 1000;

  .container {
    padding-top: 150px;
    padding-bottom: 100px;
    padding-left: 150px;
    padding-right: 150px;
  }

  .fixedFloatBar {
    z-index: $float-bar;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background-color: white;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .head {
    font-weight: 600;
    font-size: 36px;
    text-align: right;
    width: 260px;
    margin-bottom: 40px;
  }

  .subhead {
    font-size: 22px;
    margin-bottom: 30px;
  }

  i {
    margin-right: 5px;
    color: #dcdfe6;
    font-size: 20px;
  }

  .require-star {
    font-family: 'Sukhumvit';
    font-size: 18px;
    font-weight: normal;
    color: #C0C4CC;
    margin-right: 4px;
  }

  .el-button--primary.is-plain {
    background: #FFF;
    border: 2px solid #409EFF;

    &:hover {
      background: #409EFF;
    }

    &:active {
      color: #409EFF;
    }

    &:focus {
      color: #409EFF;

      &:hover {
        color: #FFFFFF;
      }
    }
  }

  .alignRight {
    text-align: right;
  }

  span.label {
    color: black;
    font-size: 18px;
    font-weight: 600;
  }

  .el-form-item {
    margin-top: -10px;
    width: 600px;
  }

  .calendar-container {
    margin-top: 10px;
    margin-bottom: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 950px;
    line-height: 20px;
  }

  .btn-calendar-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    margin-top: -10px;
  }

  .full-calendar-container {
    width: 750px;
    height: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-input {
    margin-top: -10px;
  }

  .el-textarea {
    width: 500px;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 800px;
    margin-top: 10px;
  }

  .time-select-container {
    width: 460px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .short {
    max-width: 220px;
  }

  .input-trailing-text {
    margin-left: 10px;
    margin-top: -10px;
  }

  .priceHeader {
    font-size: 18px;
    color: #c0c4cc;
    font-weight: 600;
  }

  .content {
    font-size: 18px;
    width: 400px;
  }
</style>

<style lang="scss">
  .fc-widget-content {
    background-color: #eff0f1;
  }
</style>

<script>
import DayPickerCalendar from '../shared/DayPickerCalendar'
import BookingModel from '../../model/BookingModel'

export default {
  name: 'BookingForm',
  components: {
    DayPickerCalendar,
  },
  data () {
    let customValidate = (rule, value, callback) => {
      if (!((this.form.price.rate >= 0) && (this.form.price.rate <= 9999))) {
        callback(new Error(`กรุณากรอกตัวเลข 0 - 9999`))
      } else {
        callback()
      }
    }
    return {
      allowDates: [],
      form: new BookingModel(),
      shift: {
        type: '',
        start: '',
        end: '',
      },
      workType: '',
      ca: 12,
      rules: {
        price: {
          rate: [
            { validator: customValidate, type: 'number', trigger: 'blur' },
          ],
        },
      },
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  watch: {
    booking (newVal, oldVal) {
      this.form.price = newVal.price
      this.shift = newVal.shift
      this.allowDates = newVal.dates
      this.workType = newVal.workType
      this.forceUpdateCalendar(newVal.dates)
    },
  },
  computed: {
    isDisabledSave () {
      const notValidPrice = !((this.form.price.rate >= 0) && (this.form.price.rate <= 9999))
      const notValidDate = this.form.dates.length === 0
      return notValidPrice || notValidDate
    },
    totalPrice () {
      return this.totalDays * this.form.price.rate
    },
    totalDays () {
      return this.form.dates.length
    },
    shiftSummary () {
      const shift = this.shift.type === 'day' ? 'เวรกลางวัน' : 'เวรกลางคืน'
      if (!this.shift.start) {
        return `${shift}`
      }
      return `${shift} (${this.shift.start} - ${this.shift.end})`
    },
    calendarType () {
      return this.type === 'create' ? 'createBooking' : 'editBooking'
    },
  },
  methods: {
    forceUpdateCalendar (dates) {
      this.$refs.bookingCalendar.foceUpdateData(dates)
      document.querySelectorAll('[id^="calendarBooking"] .fc-day').forEach((day) => { day.style.backgroundColor = '#eff0f1' })
    },
    goPreviousMonth () {
      this.$refs.bookingCalendar.previousMonth()
    },
    goNextMonth () {
      this.$refs.bookingCalendar.nextMonth()
    },
    async clickDelete () {
      try {
        await this.$confirm('คุณต้องการลบการหาคน ?', '', {
          confirmButtonText: 'ลบ',
          cancelButtonText: 'ยกเลิก',
          type: 'warning',
        })
        this.$emit('delete')
      } catch (error) {}
    },
    async clickCancel () {
      let action = this.type === 'create' ? 'ลงข้อมูล' : 'แก้ไขข้อมูล'
      try {
        await this.$confirm(`คุณแน่ใจว่าต้องการยกเลิกการ${action} ?`, '', {
          confirmButtonText: 'แน่ใจ',
          cancelButtonText: 'ไม่',
          type: 'warning',
        })
        this.$emit('cancel')
      } catch (error) {}
    },
    clickSave () {
      this.$emit('save', this.form)
    },
  },
  filters: {
    numberFormat (value) {
      return Number(value).toLocaleString()
    },
  },
}
</script>
